import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairTransferGuideContent } from "../../PairTransferGuideContent";

export default function TransferSpotifyToYoutubeMusic() {
    return (
        <GuidesPage
            seoData={seoContent.transferSpotifyToYoutubeMusic}
            sections={<PairTransferGuideContent sourceKey="spotify" destKey="youtubeMusic" />}
        />
    );
}
